export enum CheckIconsStates {
  CHECKED,
  UNCHECKED
}
